var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search_nodata"},[(_vm.showSearchNodata)?_c('div',{staticClass:"appear"},[_vm._m(0),_c('p',{staticClass:"desc_text"},[_vm._v("没有找到“"+_vm._s(_vm.searchContent)+"”相关的内容")])]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img_wrap2"},[_c('img',{attrs:{"src":require("../../assets/images/parent-course/search-nodata.png"),"alt":""}})])
}]

export { render, staticRenderFns }